import { render, staticRenderFns } from "./OushiDiaoxianA3.vue?vue&type=template&id=206786eb&scoped=true&"
import script from "./OushiDiaoxianA3.vue?vue&type=script&lang=js&"
export * from "./OushiDiaoxianA3.vue?vue&type=script&lang=js&"
import style0 from "./OushiDiaoxianA3.vue?vue&type=style&index=0&id=206786eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206786eb",
  null
  
)

export default component.exports